import {IReducersMap, reducer} from '../../standard-actions/reducers'
import {
  MDUM_LOAD_PLANS_DETAIL,
  MDUM_LOAD_SERVICE_DETAILS,
  MDUM_LOAD_SERVICE_USAGE,
  MOBILE_SERVICES_LIST,
  REQUEST_MOBILE_SERVICES,
  REQUEST_FEATURE_FLAGS,
  REQUEST_STRATEGIC_DEVICE_DETAILS,
  REQUEST_STRATEGIC_SIM_CONFIG_INFO,
  MOBILE_SERVICES_DETAIL_STRATEGIC,
  UPDATE_SERVICE_NICKNAME,
  VIEW_SERVICE_NICKNAME,
  REQUEST_CATEGORY_ITEM_QUESTIONS_LOAD,
  REQUESTS_CREATE,
  UPDATE_COMPANY_ID,
  LOAD_MAXIM_ACTIVITIES,
  REQUEST_PRODUCT_FAMILIES,
  DIRECTORY_LISTING,
  MOBILE_SERVICE_ETC_LEGACY,
} from '../actions/action-types'
import {IMobilityState} from '../state'
import {initialState} from '../state/initial-state'
import {loadSharedPlansReducer, LoadSharedPlansAction} from './load-shared-fairplay-plans'
import {LoadServiceDetailsAction, loadServiceDetailsReducer} from './load-service-details'
import {LoadServiceUsageAction, loadServiceUsageReducer} from './load-service-usage'
import {
  LoadMobileServicesListAction,
  loadMobileServicesListReducer,
} from './load-mobile-services-list'
import {LoadMobileServicesAction, loadMobileServicesReducer} from './load-mobile-services'
import {LoadFeatureFlagsAction, loadFeatureFlagsReducer} from './load-feature-flags'
import {
  LoadProductFamiliesAction,
  loadProductFamiliesReducer,
} from './load-product-families-reducer'
import {
  LoadStrategicDeviceDetailsAction,
  loadStrategicDeviceDetailsReducer,
} from './load-strategic-device-details'
import {
  LoadStrategicSimConfigInfoAction,
  loadStrategicSimConfigInfoReducer,
} from './load-strategic-device-sim-config-info'
import {
  LoadMobileServicesDetailStrategicAction,
  loadMobileServiceDetailsReducer,
} from './load-mobile-services-detail-strategic'
import {UpdateServiceNicknameAction, updateServiceNicknameReducer} from './update-service-nickname'
import {ViewServiceNicknameAction, viewServiceNicknameReducer} from './view-service-nickname'
import {
  RequestCategoryItemQuestionsAction,
  serviceRequestCategoryItemQuestionsReducer,
} from './request-category-item-questions-reducer'
import {UpdateCompanyIdAction, updateCompanyIdReducer} from './updated-company-id-reducer'
import {LoadMaximActivitiesAction, loadMaximActivitiesReducer} from './maxim-activities-reducer'
import {createServiceRequestReducer, RequestsAction} from './create-request'
import {LoadDirectoryListingAction, loadDirectoryListingReducer} from './load-directory-listing'
import {LegacyETCInfoAction, loadLegacyETCInfoReducer} from './load-legacy-etc'
export type MobileDataUsageMeterAction =
  | LoadSharedPlansAction
  | LoadServiceDetailsAction
  | LoadServiceUsageAction
  | LoadMobileServicesListAction
  | LoadMobileServicesAction
  | LoadFeatureFlagsAction
  | LoadProductFamiliesAction
  | LoadStrategicDeviceDetailsAction
  | LoadStrategicSimConfigInfoAction
  | LoadMobileServicesDetailStrategicAction
  | UpdateServiceNicknameAction
  | ViewServiceNicknameAction
  | RequestCategoryItemQuestionsAction
  | LoadMaximActivitiesAction
  | RequestsAction
  | UpdateCompanyIdAction
  | LoadDirectoryListingAction
  | LegacyETCInfoAction

const reducersMap: IReducersMap<IMobilityState> = {
  [MDUM_LOAD_PLANS_DETAIL]: loadSharedPlansReducer,
  [MDUM_LOAD_SERVICE_DETAILS]: loadServiceDetailsReducer,
  [MDUM_LOAD_SERVICE_USAGE]: loadServiceUsageReducer,
  [MOBILE_SERVICES_LIST]: loadMobileServicesListReducer,
  [REQUEST_MOBILE_SERVICES]: loadMobileServicesReducer,
  [REQUEST_FEATURE_FLAGS]: loadFeatureFlagsReducer,
  [REQUEST_PRODUCT_FAMILIES]: loadProductFamiliesReducer,
  [REQUEST_STRATEGIC_DEVICE_DETAILS]: loadStrategicDeviceDetailsReducer,
  [REQUEST_STRATEGIC_SIM_CONFIG_INFO]: loadStrategicSimConfigInfoReducer,
  [MOBILE_SERVICES_DETAIL_STRATEGIC]: loadMobileServiceDetailsReducer,
  [UPDATE_SERVICE_NICKNAME]: updateServiceNicknameReducer,
  [VIEW_SERVICE_NICKNAME]: viewServiceNicknameReducer,
  [REQUEST_CATEGORY_ITEM_QUESTIONS_LOAD]: serviceRequestCategoryItemQuestionsReducer,
  [LOAD_MAXIM_ACTIVITIES]: loadMaximActivitiesReducer,
  [REQUESTS_CREATE]: createServiceRequestReducer,
  [UPDATE_COMPANY_ID]: updateCompanyIdReducer,
  [DIRECTORY_LISTING]: loadDirectoryListingReducer,
  [MOBILE_SERVICE_ETC_LEGACY]: loadLegacyETCInfoReducer,
}

export const mobileDataUsageMeterReducer = reducer<IMobilityState, MobileDataUsageMeterAction>(
  reducersMap,
  initialState,
)
